import React from 'react';

export default function Whitespace(props) {
  const size = props.hasOwnProperty('small')
    ? '16px'
    : props.hasOwnProperty('smaller')
    ? '12px'
    : props.hasOwnProperty('smaller2')
    ? '8px'
    : props.hasOwnProperty('medium')
    ? '24px'
    : props.hasOwnProperty('xlarge')
    ? '64px'
    : props.hasOwnProperty('xxlarge')
    ? '72px'
    : props.hasOwnProperty('xxxlarge')
    ? '90px'
    : props.hasOwnProperty('xsmall')
    ? '4px'
    : props.hasOwnProperty('large')
    ? '48px'
    : '32px';

  return <div style={{ height: size }} />;
}



// WEBPACK FOOTER //
// ./src/components_new/common/Whitespace.js